import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppFooter',
  components: {},
  props: {},
  methods: {},
});
